import { Job29shfjfygy86k as Job } from './Job.mjs';
import { initMetadataForInterface1egvbzx539z91 as initMetadataForInterface } from '../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var CompletableJobClass;
function CompletableJob() {
  if (CompletableJobClass === VOID) {
    class $ {}
    initMetadataForInterface($, 'CompletableJob', VOID, VOID, [Job()], [0]);
    CompletableJobClass = $;
  }
  return CompletableJobClass;
}
//region block: exports
export {
  CompletableJob as CompletableJob1w6swnu15iclo,
};
//endregion

//# sourceMappingURL=CompletableJob.mjs.map
